import { createSlice } from "@reduxjs/toolkit";


const initialState: any = {
    driver: [],
    loading: false,
    error: null,
  };
const driverSlice = createSlice({
    name: "driver",
    initialState,
    reducers: {
        driverRequest(state) {
        state.loading = true;
        state.error = null;
      },
      driverSuccess(state, action) {
        state.loading = false;
        state.driver = action.payload;
      },
      driverAddSuccess(state, action) {
        state.loading = false;
        state.driver.push(action.payload);
      },
      driverEditSuccess(state, action) {
        state.loading = false;
        state.driver = state.driver.map((driver: { id: any; }) =>
          driver.id === action.payload.id ? action.payload : driver
        );
      },
      driverDeleteSuccess(state, action) {
        state.loading = false;
        state.driver = state.driver.filter((driver: { id: any; }) => driver.id !== action.payload);
      },
      driverError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
      getDriverByIdRequest(state) {
        state.loading = true;
        state.error = null;
      },
      getDriverByIdSuccess(state, action) {
        state.loading = false;
        state.user = action.payload;  
      },
      getDriverByIdError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
    },
  });

  export const {
      driverRequest,
      driverSuccess,
      driverAddSuccess,
      driverEditSuccess,
      driverDeleteSuccess,
      driverError,
      getDriverByIdRequest,
getDriverByIdSuccess,
getDriverByIdError
  } = driverSlice.actions;

export default driverSlice.reducer;
  